import { useAppDispatch, useAppState } from '@/store';
import { useEffect } from 'react';
import { GetInterLinksDTO } from '../dtos';
import {
  getLinkingTools,
  selectInterLinks,
  selectInterLinksError,
  selectInterLinksIsLoading,
  selectInterLinksPagination,
} from '../feature';

const useGetInterLinks = ({ channelId }: { channelId?: number }) => {
  const isLoading = useAppState(selectInterLinksIsLoading);
  const interLinks = useAppState(selectInterLinks);
  const pagination = useAppState(selectInterLinksPagination);
  const error = useAppState(selectInterLinksError);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isLoading || error || !channelId || interLinks) return;
    const dto = new GetInterLinksDTO({ page: '1', channelId });
    dispatch(getLinkingTools(dto)).unwrap();
  }, [channelId, dispatch, error, isLoading, interLinks]);

  return {
    isLoading,
    interLinks,
    error,
    pagination,
  };
};

export default useGetInterLinks;
